export default "__VITE_ASSET__B0YWt5co__"